module.exports = "import React from 'react';\nimport {Tabs, Tab} from 'material-ui/Tabs';\nimport FontIcon from 'material-ui/FontIcon';\nimport ActionFlightTakeoff from 'material-ui/svg-icons/action/flight-takeoff';\n\nconst TabsExampleIcon = () => (\n  <Tabs>\n    <Tab icon={<FontIcon className=\"muidocs-icon-action-home\" />} />\n    <Tab icon={<ActionFlightTakeoff />} />\n    <Tab icon={<FontIcon className=\"material-icons\">favorite</FontIcon>} />\n  </Tabs>\n);\n\nexport default TabsExampleIcon;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Tabs/ExampleIcon.js
 ** module id = 1073
 ** module chunks = 0
 **/